// extracted by mini-css-extract-plugin
module.exports = {"head":"Header_head__3gsVc","middle":"Header_middle__3EWvJ","version":"Header_version__N8V5A"};